import { UngatedHeaderWithShadow } from '@/features/shared/components/Headers/UngatedHeader/UngatedHeaderContent'
import { ProductDetailComponent } from '.'
import { HeroPromoBanner } from '@/features/shop/components/HeroPromoBanner'
import { ProductDetailHeader } from '@/features/shop/components/ProductDetail/ProductDetailHeader'
import { type InferGetServerSidePropsType } from 'next'
import { type getServerSideProps } from '@/pages/shop/products/[id]'
import dynamic from 'next/dynamic'
import { ErrorPage } from '@/features/shared/components/ErrorPage'

type Props = InferGetServerSidePropsType<typeof getServerSideProps>

const DynamicUngatedProductDetail = dynamic(
  async () =>
    await import('@/features/shop/components/UngatedProductDetail').then(
      (mod) => mod.UngatedProductDetail,
    ),
)

export const ProductDetailPage = ({ isUp, zipFromIp, productId, isGone }: Props) => {
  if (!isUp) {
    return <PDPComponent productId={productId} />
  }

  if (isGone) {
    return <ErrorPage statusCode={410} />
  }

  return (
    <>
      <UngatedHeaderWithShadow sticky />
      <DynamicUngatedProductDetail zipFromIp={zipFromIp} />
    </>
  )
}

type PDPProps = { productId: number }

export const PDPComponent = ({ productId }: PDPProps) => (
  <>
    <ProductDetailHeader productId={productId} />
    <HeroPromoBanner />
    <ProductDetailComponent productId={productId} />
  </>
)
